import ChartNivDifferentieelDiagnoseAcuutAngioOedeemSchematic from "../../../../src/client/niv_acuteboekje/json/differentiaal-diagnose-acuut-angio-oedeem-schematic.json";
import ChartNivSchematicHorizontal from "../../../../src/client/niv_acuteboekje/interactions/chart_schematic_horizontal/ChartNivSchematicHorizontal";
import * as React from 'react';
export default {
  ChartNivDifferentieelDiagnoseAcuutAngioOedeemSchematic,
  ChartNivSchematicHorizontal,
  React
};